export const Groups = [
    { value: 'CPM Registered User', label: 'CPM Registered User' },

  ];